<div class="space-y-2">
  <div class="border border-gray-400 overflow-hidden" style="height: 210px; width: 100%;">
    <video autoplay loop muted playsinline width="100%" height="auto" class="object-contain">
      <source src="/videos/download.mp4" type="video/mp4" />
    </video>
  </div>
  <div>Click the "Download" button to save the project data in the file formats you need.</div>
  <div>You can also choose to export only the selected frames.</div>
</div>
